<template>

  <form v-on:submit.prevent="">

    <BaseInputFloatinglabel v-model="form.name"
                            icon="tags"
                            placeholder="Name"
                            type="text"/>

    <div class="action">
      <BaseButton v-if="type === 'create'"
                   :loading="creating"
                   :disabled="checkForm || creating"
                   icon="plus"
                   label="Erstellen"
                   :submit="true"
                   @click="create"/>
      <BaseButton v-if="hasManagerRole && type === 'edit'"
                   :loading="removing"
                   :disabled="removing"
                   icon="trash"
                   label="Löschen"
                   :remove="true"
                   @click="remove"/>
      <BaseButton v-if="type === 'edit'"
                   :loading="updating"
                   :disabled="checkForm || updating"
                   icon="save"
                   label="Speichern"
                   :submit="true"
                   @click="update"/>
    </div>

  </form>

</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { cloneDeep } from 'lodash'

export default {
  name: 'BusinessContactCategoryForm',
  props: ['businessContactCategory', 'type'],
  data () {
    return {
      form: {},
      creating: false,
      updating: false,
      removing: false
    }
  },
  created () {
    this.form = cloneDeep(this.businessContactCategory)
  },
  methods: {
    async create () {
      try {
        this.creating = true
        const response = await this.createBusinessContactCategory({ data: this.form })
        this.$vfm.hide('business-contact-category-create')
        this.$toasted.success('B2B Kontakt Kategorie ' + response.data.name + ' erstellt', { icon: 'fas fa-tags' })
        this.creating = false
        await this.getBusinessContactCategories()
      } catch (error) {
        this.creating = false
      }
    },
    async update () {
      try {
        this.updating = true
        const response = await this.updateBusinessContactCategory({ id: this.form.id, data: this.form })
        this.$vfm.hide('business-contact-category-edit')
        this.$toasted.success('B2B Kontakt Kategorie ' + response.data.name + ' gespeichert', { icon: 'fas fa-tags' })
        this.updating = false
        await this.getBusinessContactCategory({ id: this.form.id })
      } catch (error) {
        this.updating = false
      }
    },
    async remove () {
      try {
        this.removing = true
        await this.deleteBusinessContactCategory({ id: this.form.id })
        this.$vfm.hide('business-contact-category-edit')
        this.$toasted.success('B2B Kontakt Kategorie gelöscht', { icon: 'fas fa-tags' })
        this.removing = false
        await this.getBusinessContactCategories()
      } catch (error) {
        this.removing = false
      }
    },
    ...mapActions({
      createBusinessContactCategory: 'businessContactCategories/create',
      updateBusinessContactCategory: 'businessContactCategories/replace',
      deleteBusinessContactCategory: 'businessContactCategories/destroy',
      getBusinessContactCategory: 'businessContactCategories/fetchSingle',
      getBusinessContactCategories: 'businessContactCategories/fetchList'
    })
  },
  computed: {
    checkForm () {
      return !(this.form.name)
    },
    ...mapGetters({
      hasManagerRole: 'auth/hasManagerRole'
    })
  }
}
</script>
